// src/layouts/Pages/PageHeader/CardHeaderColumns/items/documentCode.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { BorderlessTableOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { copyToClipboard } from 'utils/copyToClipboard';
import CursorPointer from 'components/JarvislyComponents/CursorPointer';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const documentCodeItem = record => {
  const docCode =
    record?._metadata?.__documentCode?.toUpperCase() ||
    (record?._id && `1.${record?._id?.slice(-6)}`);

  return {
    key: 'documentCode',
    icon: <BorderlessTableOutlined />,
    label: docCode ? <CursorPointer>{docCode?.toString()?.toUpperCase()}</CursorPointer> : null,
    tooltipText: translateX('document_code'),
    tooltipPlacement: 'right',
    onClick: record?._id ? () => copyToClipboard(record._id, 'document_id_copied') : null,
  };
};

export default documentCodeItem;
